import { useData } from '../hooks/useData';
import { useFilter } from '../hooks/useFilter';
import { WordType } from '../types/SharedTypes';
import AlphabetFilter from './molecules/AlphabetFilter';
import List from './molecules/List';

type AppType = {
	dataUrl: string;
};

export default function App(props: AppType) {
	const { dataUrl } = props;
	const { data, error, isLoadingAppData } = useData(dataUrl);

	const words: Record<string, WordType[]> = data?.words || {};
	const { filter, setFilter, getFilteredWords } = useFilter({ data: { words } });

	function getLabel(key: string) {
		return data?.labels[key] || '';
	}

	if (isLoadingAppData || error || !data) {
		return null;
	}

	return (
		<>
			<AlphabetFilter words={words} getLabel={getLabel} activeFilter={filter} onFilterChange={setFilter} />
			<List words={getFilteredWords()} getLabel={getLabel} />
		</>
	);
}
